import { useInstance } from '@meraki-internal/react-dependency-injection';
import { Button } from '../../components/button/Button.tsx';
import { TrackingService } from '../../support/tracking/TrackingService.ts';
import { MissionsState } from '../model/MissionsState.ts';
import { MapViewModel } from '../../map/model/MapViewModel.ts';
import { HistoryViewModel } from '../../app/HistoryViewModel.ts';
import { PlaneIcon } from '../../components/icons/Icons.tsx';

export const NewMissionButton: React.FC<{ fullWidth?: boolean; }> = ({ fullWidth }) => {
    const map = useInstance(MapViewModel);
    const vm = useInstance(MissionsState);
    const tracker = useInstance(TrackingService);
    const history = useInstance(HistoryViewModel);

    const onClick = () => {
        tracker.track('New Mission Button Tapped');

        // if they click "new mission" before moving the map, use burlington as a demo
        const sampleLocation = { lat: 44.476505, lng: -73.221054 };
        const coordinates = map.isInitialCenter() ? sampleLocation : map.getCenter();

        const dropPin = `${coordinates.lng},${coordinates.lat}`;
        history.push(vm.pages.new.path({ dropPin }));
    };

    return (
        <div style={{
            textAlign: 'center',
            ...(fullWidth ? { width: '100%'} : {})
        }}>
            <Button expand="block" onClick={onClick} dataType="create-mission-button">
                <PlaneIcon />
                <span style={{ marginLeft: 6 }}>New Mission</span>
            </Button>
        </div>
    );
};
